import { Repository } from "./adapters/repository";

import * as retrieveRoles from "./useCases/retrieveRoles";
import * as retrievePlanzoneRole from "./useCases/retrievePlanzoneRole";
import * as retrieveZoneRole from "./useCases/retrieveZoneRole";
import * as retrieveProjectRole from "./useCases/retrieveProjectRole";
import * as retrieveProjectsRoles from "./useCases/retrieveProjectsRoles";
import * as retrieveAccessRestrictions from "./useCases/retrieveAccessRestrictions";
import * as editAccessRestrictions from "./useCases/editAccessRestrictions";

enum UseCases {
  retrieveRoles = "retrieveRoles",
  retrievePlanzoneRole = "retrievePlanzoneRole",
  retrieveZoneRole = "retrieveZoneRole",
  retrieveProjectRole = "retrieveProjectRole",
  retrieveProjectsRoles = "retrieveProjectsRoles",
  retrieveAccessRestrictions = "retrieveAccessRestrictions",
  editAccessRestrictions = "editAccessRestrictions",
}

interface Core {
  [UseCases.retrieveRoles]: retrieveRoles.Interactor;
  [UseCases.retrievePlanzoneRole]: retrievePlanzoneRole.Interactor;
  [UseCases.retrieveZoneRole]: retrieveZoneRole.Interactor;
  [UseCases.retrieveProjectRole]: retrieveProjectRole.Interactor;
  [UseCases.retrieveProjectsRoles]: retrieveProjectsRoles.Interactor;
  [UseCases.retrieveAccessRestrictions]: retrieveAccessRestrictions.Interactor;
  [UseCases.editAccessRestrictions]: editAccessRestrictions.Interactor;
}

type Boundaries = BoundaryMap<Core>;

type Dependencies = {
  repository: Repository;
};

function createCore(dependencies: Dependencies): Core {
  return {
    [UseCases.retrieveRoles]: retrieveRoles.createInteractor(
      dependencies.repository,
    ),
    [UseCases.retrievePlanzoneRole]: retrievePlanzoneRole.createInteractor(
      dependencies.repository,
    ),
    [UseCases.retrieveZoneRole]: retrieveZoneRole.createInteractor(
      dependencies.repository,
    ),
    [UseCases.retrieveProjectRole]: retrieveProjectRole.createInteractor(
      dependencies.repository,
    ),
    [UseCases.retrieveProjectsRoles]: retrieveProjectsRoles.createInteractor(
      dependencies.repository,
    ),
    [UseCases.retrieveAccessRestrictions]:
      retrieveAccessRestrictions.createInteractor(dependencies.repository),
    [UseCases.editAccessRestrictions]: editAccessRestrictions.createInteractor(
      dependencies.repository,
    ),
  };
}

export type { Core, Boundaries, Dependencies };

export { UseCases, createCore };
